import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getPlanPageThemeColors } from 'redux/ThemeSlice';

import NewHeader from './NewHeader';
import PlanPageContent from './components/PlanPageContent';
import { usePlanPageUiRevamp } from './usePlanPageUiRevamp';

const PlanPageUIRevamp = () => {
  const isEnabled = usePlanPageUiRevamp();
  const themeColors = useSelector(getPlanPageThemeColors);

  if (!isEnabled) {
    return null;
  }

  return (
    <Box
      h='100%'
      display='flex'
      flexDirection='column'
      bg={themeColors.background}
      overflow='hidden'
      fontFamily='regular_roboto'
    >
      <NewHeader />
      <PlanPageContent />
    </Box>
  );
};

export default PlanPageUIRevamp;
